// base component
import { ToolbarComponent } from './toolbar.component';

// components


export const ToolbarModule = angular.module('topbroker.toolbars', [])
  .component('toolbar', ToolbarComponent)
  .name;